import React from "react";
import axios from "axios";
import Select from "react-select";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import { ToastContainer, toast } from "react-toastify";
import loading from "./assets/loading.gif";

import "./DocumentEmails.css";
import "font-awesome/css/font-awesome.min.css";

const ALL_WAREHOUSES = { value: "", label: "All warehouses" };

class DocumentEmails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      recipients: [],
      warehouseOptions: [ALL_WAREHOUSES],
      email: "",
      name: "",
      warehouseExternalId: "",
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });

    const warehouses = (await axios.get("/api/warehouses")).data.map(
      (warehouse) => ({
        value: warehouse.external_id,
        label: warehouse.name,
      })
    );

    const recipients = (await axios.get("/api/document_email_recipients")).data;

    this.setState({
      loading: false,
      recipients,
      warehouseOptions: [ALL_WAREHOUSES, ...warehouses],
    });
  }

  getWarehouseOption(externalId) {
    return (
      this.state.warehouseOptions.find(
        (option) => option.value === (externalId || "")
      ) || ALL_WAREHOUSES
    );
  }

  handleError = (e) => {
    const detail = e.response?.data?.error?.detail;

    if (detail) {
      toast.error(
        Object.entries(detail)
          .map(([field, messages]) => `${field} ${messages.join(", ")}`)
          .join("; ")
      );
    } else {
      toast.error(e.message);
    }
  };

  createRecipient = async () => {
    try {
      const recipients = (
        await axios.post("/api/document_email_recipients", {
          email: this.state.email,
          name: this.state.name,
          warehouse_external_id: this.state.warehouseExternalId,
        })
      ).data;

      this.setState({ recipients, email: "", name: "" });
      toast.success("Recipient added.");
    } catch (e) {
      this.handleError(e);
    }
  };

  updateRecipient = async (id, attributes) => {
    try {
      const recipients = (
        await axios.put(`/api/document_email_recipients/${id}`, attributes)
      ).data;

      this.setState({ recipients });
    } catch (e) {
      this.handleError(e);
    }
  };

  deleteRecipient = async (id) => {
    try {
      const recipients = (
        await axios.delete(`/api/document_email_recipients/${id}`)
      ).data;

      this.setState({ recipients });
    } catch (e) {
      this.handleError(e);
    }
  };

  render() {
    return (
      <div className="document-emails-container">
        <ToastContainer />
        <p>
          These addresses receive the shipping documents (BOL, labels, customs
          invoice, packing instructions) that are emailed when an order is sent
          to a warehouse.
        </p>
        <p>
          A recipient set to <b>All warehouses</b> receives documents for every
          order. A recipient assigned to a warehouse only receives documents for
          orders shipping from that warehouse.
        </p>
        <p>
          Uncheck <b>Active</b> to stop sending to an address without losing it.
          Champion orders are pushed to Google Drive instead of emailed, so
          Champion recipients here have no effect.
        </p>

        <div className="document-emails-bar">
          <InputGroup>
            <div className="document-emails-field">
              <label className="document-emails-field-label">Email</label>
              <FormControl
                className="document-emails-field-email"
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
              />
            </div>
            <div className="document-emails-field">
              <label className="document-emails-field-label">
                Name (Optional)
              </label>
              <FormControl
                className="document-emails-field-name"
                value={this.state.name}
                onChange={(e) => this.setState({ name: e.target.value })}
              />
            </div>
            <div className="document-emails-field">
              <label className="document-emails-field-label">Warehouse</label>
              <Select
                className="document-emails-warehouse"
                classNamePrefix="document-emails-warehouse"
                options={this.state.warehouseOptions}
                value={this.getWarehouseOption(this.state.warehouseExternalId)}
                onChange={(selection) =>
                  this.setState({ warehouseExternalId: selection.value })
                }
              />
            </div>
          </InputGroup>

          <div className="document-emails-buttons">
            <Button
              variant="success"
              className="document-emails-field-button"
              disabled={!this.state.email}
              onClick={this.createRecipient}
            >
              + Add Recipient
            </Button>
          </div>
        </div>

        {!this.state.loading && (
          <div className="vertical">
            <Table striped bordered hover className="document-emails-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Email</th>
                  <th>Name</th>
                  <th>Warehouse</th>
                  <th>Active</th>
                </tr>
              </thead>
              <tbody>
                {this.state.recipients.map((recipient) => {
                  return (
                    <tr key={recipient.id}>
                      <td>
                        <Button
                          variant="danger"
                          onClick={() => this.deleteRecipient(recipient.id)}
                        >
                          Delete
                        </Button>
                      </td>
                      <td>{recipient.email}</td>
                      <td>{recipient.name}</td>
                      <td>
                        <Select
                          className="document-emails-warehouse"
                          classNamePrefix="document-emails-warehouse"
                          options={this.state.warehouseOptions}
                          value={this.getWarehouseOption(
                            recipient.warehouse_external_id
                          )}
                          onChange={(selection) =>
                            this.updateRecipient(recipient.id, {
                              warehouse_external_id: selection.value,
                            })
                          }
                        />
                      </td>
                      <td className="document-emails-check">
                        <input
                          type="checkbox"
                          checked={recipient.active}
                          onChange={() =>
                            this.updateRecipient(recipient.id, {
                              active: !recipient.active,
                            })
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}

        {this.state.loading && (
          <div className="loading-container">
            <div className="loading-title">Loading...</div>
            <img className="loading" src={loading} alt="" />
          </div>
        )}
      </div>
    );
  }
}

export default DocumentEmails;
